<template>
  <form class="info-form" @submit.prevent="submitHandler">
    <fieldset class="info-form__fieldset">
      <FormElement
        v-model:value.trim="fields.title"
        title="Наименование информационного блока"
        titleClass="black-18"
        placeholder="Введите наименование"
        :errorText="errorFields?.title"
        isRequired
      />
      <SelectElement
        v-if="!isEditing"
        :value="fields.template.name ? fields.template : templates[0]"
        :options="templates"
        objectKey="template"
        label="nameRu"
        trackBy="name"
        title="Используемый шаблон"
        titleClass="medium-18"
        :errorText="errorFields?.template"
        isRequired
        @dataChanged="onValueUpdate"
      />
      <VideoLinkField
        v-if="isVideo"
        v-model:value="fields.videoUrl"
        :link="block?.videoLink ?? null"
        :errorText="errorFields?.videoUrl"
        title="Ролик VK Видео или Rutube"
      />
      <CheckboxRadioElement
        label="Активен"
        fieldKey="isActive"
        :value="!fields.isActive"
        :checked="!!fields.isActive"
        @update:value="onValueUpdate"
      />
      <NotifyComponent v-if="!!error" :text="error" />
    </fieldset>
    <FormActionBtns
      reversed
      :isLoading="isLoading"
      :disabled="!fields.title || (isVideo && !fields.videoUrl.trim())"
      @cancel="$emit('close')"
    >
      {{ isEditing ? 'Сохранить  изменения' : 'Создать блок' }}
    </FormActionBtns>
  </form>
</template>

<script lang="ts" src="./HomeInfoForm.ts"></script>

<style scoped lang="scss" src="./HomeInfoForm.scss"></style>
